import classNames from 'classnames';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { v4 as uuidv4 } from 'uuid';

import Dropdown from '../Atoms/Dropdown';

const propTypes = exact({
  handleChange: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  max: PropTypes.number,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ),
  selectedValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  showBeyondMaxOption: PropTypes.bool,
  hideLabel: PropTypes.bool,
  className: PropTypes.string,
});

const defaultProps = {
  labelText: 'How many?',
  max: undefined,
  showBeyondMaxOption: false,
  options: undefined,
  hideLabel: false,
  className: null,
};

function UpgradeDropdown(props) {
  const dropdownId = useMemo(() => uuidv4(), []);
  let options = props.options || [];
  if (options.length === 0 && props.max) {
    options = [...Array(props.max)].map((_, index) => ({
      text: index + 1,
      value: index + 1,
    }));
  }

  if (props.showBeyondMaxOption) {
    options.push({ text: `${props.max} +`, value: props.max + 1 });
  }

  return (
    <div
      className={classNames('UpgradeDropdown', props.className, {
        'UpgradeDropdown-hideLabel': props.hideLabel,
      })}
    >
      {!props.hideLabel && (
        <>
          {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
          <label
            className="UpgradeDropdown_label"
            htmlFor={dropdownId}
            onClick={(e) => {
              e.preventDefault();
              document.getElementById(dropdownId)?.showPicker();
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                document.getElementById(dropdownId)?.showPicker();
              }
            }}
          >
            {props.labelText}
          </label>
        </>
      )}
      <Dropdown
        blockName="UpgradeDropdown_dropdown"
        fieldValue={props.selectedValue}
        handleChange={props.handleChange}
        modifier="bold"
        options={options}
        id={dropdownId}
      />
    </div>
  );
}

UpgradeDropdown.propTypes = propTypes;
UpgradeDropdown.defaultProps = defaultProps;

export default UpgradeDropdown;
